export default {"src":"/_next/static/media/chennai.2cc54427.svg","height":78,"width":132};